// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wcc-alert{display:block;background-color:#35889b;padding-left:10px}.wcc-alert__body{padding:15px;background-color:#45aac2;color:#fff}", ""]);
// Exports
module.exports = exports;
